import React from "react";

import { EnvironmentStorage } from "../../../tools/EnvironmentStorage";
import BlingAppDrawer from "./BlingAppDrawer";
import BlingStoreDrawer from "./BlingStoreDrawer";

export default class BlingDrawer extends React.Component {
  render() {
    const { visible, onClose } = this.props;

    const environment = EnvironmentStorage.getEnvironment();
    const isBrand = environment.type === "BRAND";

    return isBrand ? (
      <BlingAppDrawer visible={visible} onClose={onClose} />
    ) : (
      <BlingStoreDrawer visible={visible} onClose={onClose} />
    );
  }
}
